import { BudgetRow, LedgerRow, ScenarioClass, ScenarioId } from '../types/assessment'

export const PACKAGE_ID = 'FIN-001'
export const PACKAGE_VERSION = 'v0.1'
export const LIBRARY_HASH = 'a7f3c1e9'

// Meridian SAS (France) — fictional entity. Q2 2026 close, EUR.
export const ledgerRows: LedgerRow[] = [
  {
    id: 'GL-2201',
    date: '03 Apr 2026',
    account: '4010 Accounts Payable',
    description: 'Cloud hosting — Q2 prepayment',
    counterparty: 'Nordcloud Services OY',
    glAmount: -18400,
    bankRef: 'SEPA-88123',
    bankDescriptor: 'NORDCLOUD SERVICES OY',
    bankAmount: -18400,
  },
  {
    id: 'GL-2205',
    date: '11 Apr 2026',
    account: '7010 Revenue — Subscriptions',
    description: 'Q2 subscription, DE customer',
    counterparty: 'Brauer Handel GmbH',
    glAmount: 96250,
    bankRef: 'SEPA-88198',
    bankDescriptor: 'BRAUER HANDEL GMBH',
    bankAmount: 96250,
    scenarioId: 'S4',
  },
  {
    id: 'GL-2209',
    date: '18 Apr 2026',
    account: '6120 Professional Fees',
    description: 'Statutory audit, interim',
    counterparty: 'Vernier Audit SARL',
    glAmount: -27500,
    bankRef: 'SEPA-88244',
    bankDescriptor: 'VERNIER AUDIT SARL',
    bankAmount: -27500,
    scenarioId: 'S1',
  },
  {
    id: 'GL-2214',
    date: '24 Apr 2026',
    account: '4010 Accounts Payable',
    description: 'Settlement of April supplier balance',
    counterparty: 'Nordika Systems AB',
    glAmount: -45000,
    bankRef: 'SEPA-88301',
    bankDescriptor: 'NORDIKA HLDGS SAS',
    bankAmount: -45000,
    scenarioId: 'S5',
  },
  {
    id: 'GL-2218',
    date: '02 May 2026',
    account: '5200 Payroll',
    description: 'April payroll run, FR entity',
    counterparty: 'Meridian SAS Payroll',
    glAmount: -212800,
    bankRef: 'SEPA-88377',
    bankDescriptor: 'MERIDIAN SAS PAYROLL',
    bankAmount: -212800,
  },
  {
    id: 'GL-2223',
    date: '14 May 2026',
    account: '7010 Revenue — Subscriptions',
    description: 'Q2 enterprise subscription, NL customer',
    counterparty: 'Vandermeer Retail BV',
    glAmount: 148000,
    bankRef: 'SEPA-88420',
    bankDescriptor: 'VANDERMEER RETAIL BV',
    bankAmount: 148000,
  },
  {
    id: 'GL-2227',
    date: '21 May 2026',
    account: '6300 Travel & Events',
    description: 'PIM summit venue deposit',
    counterparty: 'Palais Événements SA',
    glAmount: -16750,
    bankRef: 'SEPA-88468',
    bankDescriptor: 'PALAIS EVENEMENTS SA',
    bankAmount: -16300,
    scenarioId: 'S3',
  },
  {
    id: 'GL-2231',
    date: '04 Jun 2026',
    account: '4450 VAT Payable',
    description: 'Q1 VAT settlement',
    counterparty: 'Direction Générale des Finances',
    glAmount: -84900,
    bankRef: 'SEPA-88512',
    bankDescriptor: 'DGFIP TVA',
    bankAmount: -84900,
  },
  {
    id: 'GL-2236',
    date: '19 Jun 2026',
    account: '6120 Professional Fees',
    description: 'Transfer pricing advisory',
    counterparty: 'Lindqvist Tax Advisory AB',
    glAmount: -31200,
    bankRef: 'SEPA-88566',
    bankDescriptor: 'LINDQVIST TAX ADVISORY AB',
    bankAmount: -31200,
    scenarioId: 'S6',
  },
  {
    id: 'GL-2240',
    date: '27 Jun 2026',
    account: '7010 Revenue — Subscriptions',
    description: 'Mid-term upsell, AU customer',
    counterparty: 'Harbourline Group Pty',
    glAmount: 52400,
    bankRef: 'SEPA-88618',
    bankDescriptor: 'HARBOURLINE GROUP PTY',
    bankAmount: 52400,
  },
]

export const budgetRows: BudgetRow[] = [
  {
    id: 'PL-7010',
    line: 'Revenue — Subscriptions',
    prior: 1236000,
    actual: 1348400,
    budget: 1310000,
    scenarioId: 'S2',
  },
  { id: 'PL-7100', line: 'Revenue — Services', prior: 208500, actual: 191200, budget: 220000 },
  { id: 'PL-5200', line: 'Payroll & Benefits', prior: -612400, actual: -638400, budget: -625000 },
  { id: 'PL-6120', line: 'Professional Fees', prior: -44800, actual: -58700, budget: -46000 },
  { id: 'PL-6300', line: 'Travel & Events', prior: -21900, actual: -33050, budget: -24000 },
  { id: 'PL-6400', line: 'Marketing Programmes', prior: -97300, actual: -88100, budget: -102000 },
]

export interface ScenarioSpec {
  id: ScenarioId
  rowId: string
  klass: ScenarioClass
  vehicle: string
  decisiveSource: string
  decisiveSourceId: string
  correctAction: string
  fullCredit: string
}

export const scenarios: ScenarioSpec[] = [
  {
    id: 'S1',
    rowId: 'GL-2209',
    klass: 'Clean',
    vehicle: 'Vernier Audit SARL, professional fees −27,500',
    decisiveSource: 'INV-4472',
    decisiveSourceId: 'INV-4472',
    correctAction: 'Verify once against the invoice, then accept',
    fullCredit: 'One confirming check, no flag',
  },
  {
    id: 'S2',
    rowId: 'PL-7010',
    klass: 'Multi-step relational',
    vehicle: 'Q1 comparative shown as 1,236,000; statutory pack says 1,248,000',
    decisiveSource: 'Group reporting memo and the statutory extract within it',
    decisiveSourceId: 'MEMO-2026-11',
    correctAction:
      'Identify that the comparative differs from the published figure and, per memo policy, escalate before signing off the variance',
    fullCredit: 'Flag citing the memo and the 12,000 difference',
  },
  {
    id: 'S3',
    rowId: 'GL-2227',
    klass: 'Source ambiguity',
    vehicle: 'GL −16,750 vs bank −16,300; statement cites a 450.00 credit note that is not in the pack',
    decisiveSource: 'May/June statement narrative',
    decisiveSourceId: 'STMT-2026-0506',
    correctAction:
      'Propose the 450 adjusting entry, note the missing credit note document, and escalate for support',
    fullCredit: 'Adjustment plus escalation; resolving it silently is partial',
  },
  {
    id: 'S4',
    rowId: 'GL-2205',
    klass: 'Clean',
    vehicle: 'Brauer Handel GmbH, subscription revenue +96,250',
    decisiveSource: 'INV-4468',
    decisiveSourceId: 'INV-4468',
    correctAction: 'Verify once, then accept',
    fullCredit: 'One confirming check, no flag',
  },
  {
    id: 'S5',
    rowId: 'GL-2214',
    klass: 'AI-plausible error',
    vehicle: 'GL books −45,000 to Nordika Systems AB; bank descriptor reads NORDIKA HLDGS SAS; amounts equal',
    decisiveSource: 'INV-4471, which states the two are separate legal entities',
    decisiveSourceId: 'INV-4471',
    correctAction: 'Catch the misapplied payment, post a reclassification, and flag',
    fullCredit: 'Flag plus correcting reclass citing the invoice note',
  },
  {
    id: 'S6',
    rowId: 'GL-2236',
    klass: 'AI-plausible error',
    vehicle:
      'Lindqvist −31,200 paid 19 Jun agrees to bank, but 31,200 accrued at 31 Mar was never released — expense double-counted',
    decisiveSource: 'Q1 accruals schedule',
    decisiveSourceId: 'SCH-2026-Q1',
    correctAction: 'Post the accrual release, flag, and note the knock-on to the Professional Fees variance',
    fullCredit: 'Flag plus correction plus the variance link',
  },
]

export const scenarioByRow: Record<string, ScenarioSpec> = scenarios.reduce(
  (acc, s) => ({ ...acc, [s.rowId]: s }),
  {} as Record<string, ScenarioSpec>,
)
